export const countiesList = ["Budapest", "Bács-Kiskun", "Baranya", "Békés", "Borsod-Abaúj-Zemplén", "Csongrád", "Fejér", "Győr-Moson-Sopron", "Hajdú-Bihar", "Heves", "Jász-Nagykun-Szolnok", "Komárom-Esztergom", "Nógrád", "Pest", "Somogy", "Szabolcs-Szatmár-Bereg", "Tolna", "Vas", "Veszprém", "Zala"];
export const agesList = ["18-21", "22-25", "26-30", "30+"]

export const engHunGenderTranslator = (englishGender) => {
    if (englishGender === 'male') return 'Férfi'
    if (englishGender === 'female') return 'Nő'
    return 'Nem szeretném megadni'
}

export const educationList = ['Általános iskola, 8 osztály', 'Gimnáziumi érettségi', 'BA/BSc vagy Főiskolai diploma', 'MA/MSc vagy Egyetemi diploma', 'PhD', 'egyéb, kérjük add meg']